module.exports = "/fonts/nucleo-icons.ttf?a30d0b0201482fcfffd3cab31d1e9055";